import { render, staticRenderFns } from "./ConfigBox.vue?vue&type=template&id=96d8863a&scoped=true&"
import script from "./ConfigBox.vue?vue&type=script&lang=js&"
export * from "./ConfigBox.vue?vue&type=script&lang=js&"
import style0 from "./ConfigBox.vue?vue&type=style&index=0&id=96d8863a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96d8863a",
  null
  
)

export default component.exports